import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'

import { IsAuthorized } from 'src/authentication/IsAuthorized'

class SupplierPaymentOrderServices {
  async authorize(id: number): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/supplier-payment-order/authorize/${id}`,
        {},
        { headers: { 'authentication-token': getJWT()! } }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async unauthorize(id: number): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/supplier-payment-order/unauthorize/${id}`,
        {},
        { headers: { 'authentication-token': getJWT()! } }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createPaymentOrder(payload: any): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/supplier-payment-order/items/`,
        payload,
        { headers: { 'authentication-token': getJWT()! } }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const supplierPaymentOrderServices = new SupplierPaymentOrderServices()
